// extracted by mini-css-extract-plugin
export default {"main":"main_main__EQXkR","paper":"main_paper__1jFef","buttons":"main_buttons__xoqBn"};